module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-loading",
    class: 'comp-loading--' + _vm.type
  }, [(_vm.type === 'block') ? _c('div', {
    staticClass: "m-loading"
  }, [_c('div', {
    staticClass: "rect rect1"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect2"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect3"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect4"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect5"
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'inline') ? _c('div', {
    staticClass: "m-loading-point"
  }, [_c('div', {
    staticClass: "bounce bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce bounce3"
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d9ed309", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d9ed309!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Loading.vue
// module id = 19
// module chunks = 0 1